module.exports = __webpack_public_path__ + "img/event.9fcf9ba8.png";